import React from 'react';
import { Box, Text } from '@mantine/core';
import { When } from '../../../components/common';

type RuleBlockContentProps = {
    condition: string;
    formula: string;
    example?: string;
};

function RuleBlockContent({
    condition,
    formula,
    example,
}: RuleBlockContentProps) {
    return (
        <Box className="rounded-md bg-[#f4f5f7] px-3 py-2.5">
            <Text size="xs" c="dimmed" lh={1.5}>
                {condition}
            </Text>
            <Text size="sm" fw={600} c="primary" mt={8} lh={1.4}>
                {formula}
            </Text>
            <When condition={!!example}>
                <Text size="xs" c="dimmed" mt={6} className="italic">
                    {example}
                </Text>
            </When>
        </Box>
    );
}

type RuleBlockProps = RuleBlockContentProps & {
    showDivider?: boolean;
};

export function RuleBlock({
    condition,
    formula,
    example,
    showDivider,
}: RuleBlockProps) {
    const content = (
        <RuleBlockContent
            condition={condition}
            formula={formula}
            example={example}
        />
    );

    return (
        <When condition={!!showDivider} fallback={content}>
            <Box className="border-b border-[#e6e9ef] pb-3 mb-3">{content}</Box>
        </When>
    );
}
